import React, { useMemo } from "react";
import { useStaticQuery, graphql } from "gatsby";
import MicroCopy from "@unum/micro-copy";
import { GetAllMicroCopyQuery } from "../../graphql-types";

type Props = {
  children: React.ReactNode;
};

const IntegratedMicroCopy = ({ children }: Props) => {
  const microCopyQuery = useStaticQuery<GetAllMicroCopyQuery>(query);
  const data = microCopyQuery?.allKontentItemMicrocopy?.nodes || [];
  // @ts-expect-error It's expecting MicroCropyFragmentFragment type, which is
  // more precise type. However, this matches the more generic values expected
  // by MicroCopy.Provider.
  const values = useMemo<Record<string, string>>(() => {
    return data.reduce((carry, { elements: { key, value } }) => {
      return {
        ...carry,
        [key.value.toLowerCase()]: value.value
      };
    }, {});
  }, [data]);

  return <MicroCopy.Provider values={values}>{children}</MicroCopy.Provider>;
};

export default IntegratedMicroCopy;

const query = graphql`
  fragment MicroCopyFragment on kontent_item_microcopy {
    elements {
      key {
        value
      }
      value {
        value
      }
    }
  }

  query getAllMicroCopy {
    allKontentItemMicrocopy {
      nodes {
        ...MicroCopyFragment
      }
    }
  }
`;
